import {USUARIO} from '../config/constantes/constantes-mantine';
import {Usuario} from "../tipos/usuario";
import {SetorDto} from "../tipos/dto/setor-dto";

export const getUsuarioLogado = () => {
  let usuario: Usuario = JSON.parse(localStorage.getItem(USUARIO) as string);
  if (usuario !== null) {
    if (usuario.setor === null) {
      let setor: SetorDto = new SetorDto();
      setor.nome = 'Sem Setor Definido';
      usuario.setor = setor
    }
  }
  return usuario;
}

export const logado = () => {
  const url = window.location.href
  if (url === 'http://localhost:3000/' || url === 'https://asplan.ssp.se.gov.br/') return false
  return JSON.parse(localStorage.getItem(USUARIO) as string) !== null;

}